import type { CancelPopupText } from '../../../../../common/CancelPopup/CancelPopup';
import { translate } from '../../../../../common/helpers/translate.helper';
import { OfferState } from '../../../../../offer/model/OfferState';

export const getCustomerOfferCancelPopupText = (
    offerState: OfferState,
    isLastOpenOffer: boolean,
    isSpotAvailable: boolean
): CancelPopupText => {
    let description = translate('order.detail.offerCard.cancelPopup.description');

    if (isLastOpenOffer) {
        description = isSpotAvailable
            ? translate('order.detail.offerCard.cancelPopup.lastOpen.descriptionWithSpot')
            : translate('order.detail.offerCard.cancelPopup.lastOpen.description');
    }

    if (offerState === OfferState.ENQUIRY) {
        return {
            headline: translate('order.detail.offerCard.cancelPopup.enquiry.headline'),
            description,
            buttonText: translate('order.detail.offerCard.cancelPopup.enquiry.button'),
        };
    }

    return {
        headline: translate('order.detail.offerCard.cancelPopup.quoted.headline'),
        description,
        buttonText: translate('order.detail.offerCard.cancelPopup.quoted.button'),
    };
};
